export const CONFIGURABLE_ACTIONS_OWNER  = 'SignalR Actions';
export const CONFIGURABLE_ACTIONS_NAME  = 'Broadcast';
